import {
  HTTPValidationError,
  deleteSeriesMetadataQcTasksSeriesDelete,
  DeleteSeriesMetadataQcTasksSeriesDeleteData,
  DeleteSeriesMetadataQcTasksSeriesDeleteResponse,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useDeleteSeriesMetadataMutation = (): UseMutationResult<
  DeleteSeriesMetadataQcTasksSeriesDeleteResponse,
  AxiosError<HTTPValidationError>,
  DeleteSeriesMetadataQcTasksSeriesDeleteData
> => {
  return useMutation<
    DeleteSeriesMetadataQcTasksSeriesDeleteResponse,
    AxiosError<HTTPValidationError>,
    DeleteSeriesMetadataQcTasksSeriesDeleteData
  >({
    mutationFn: async (query) => {
      const response = await deleteSeriesMetadataQcTasksSeriesDelete({
        query: query.query,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['QCTask'] })
    },
  })
}
